import { render, staticRenderFns } from "./LegalFeesCalculatorTable.vue?vue&type=template&id=54e22063"
import script from "./LegalFeesCalculatorTable.vue?vue&type=script&lang=js"
export * from "./LegalFeesCalculatorTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports